import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { MFLEntity } from "../../../Data/MedicinalProductData/MFLEntity";
import { BaseNode } from "../../BaseNode";
import { TreeNodeMasterFileLocationList } from "../../Art57Node/ListEntity/TreeNodeMasterFileLocationList"; 
import { environment } from "../../../../../../environments/environment";


export class MFLAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload: boolean, cloningNode: boolean) {
        const createChildTemplateparams = {nodeType:2};
        super(injector, labelTemplate, MFLEntity, useHist ? AutoUploadEntityEnum.mflHist : AutoUploadEntityEnum.mfl, ServiceEnum.MedicinalProducts, parent, model, TreeNodeMasterFileLocationList,false, disableAutoUpload,cloningNode, createChildTemplateparams);
        this.labelNodeName = 'Master File Location';
        this.useHist = useHist;
      }

    override cloneNode(newParent: BaseNode): BaseNode {
      let clonedNode: MFLAutoUploadEntity = new MFLAutoUploadEntity(this.ioc!, this.label!, newParent, this.datasource, false, this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      clonedNode.cloningNode = false;
      return clonedNode;

    }

}